function authCheck(type) {
  const lv = localStorage.getItem('level')
  
  if (type === 'ADMIN') {
    if (lv !== '0') {
        window.alert('잘못된 접근입니다.')
        return false
    } else {
        return true
    }
  } else if (type === 'CERTI') {
    if (lv !== '0' && lv !== '1') {
        window.alert('사업자 인증이 필요한 서비스입니다.')
        return false
      } else {
        return true
      }
  } else if (type === 'NORMAL') {
    console.log(lv)
    if (lv === null) {
        window.alert('로그인이 필요한 서비스입니다.')
        return false
      } else {
        return true
      }
  } else {
    alert('고객센터에 문의하세요.')
    return false
  }
}

export default authCheck;